// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__Tn-ee","active":"navigation_active__t5Mki"};